
<div *ngIf="isESGFilterLoading" class="loadingContainer">
  <app-loader [isLoading]="isESGFilterLoading"></app-loader>
</div>
<div *ngIf="summarySidebarVisible" class="card ESGContainer">
  <div class="flex align-items-center justify-content-start my-3">
    <i (click)="summarySidebarVisible=false" class="bi bi-arrow-left back-button"></i>
    <h4  class="ml-3">{{ headerSummary }} - {{ summaryDocumentName }}</h4>
  </div>
  <div [markdown]="true">{{summaryData}} </div>
</div>
<div *ngIf="!isESGFilterLoading && !summarySidebarVisible" class="card ESGContainer">
  <p class="heading">Tags</p>
  <p-multiSelect
      [options]="ESGtagsList"
      [(ngModel)]="selectedESGTags"
      placeholder="Select Tags"
      optionLabel="tag"
      (onPanelShow)="onMultiSelectOpen()"
      display="chip"
      class="custom-multiSelect mt-1"
      [showClear]="true"
  >
  </p-multiSelect>

  <p class="heading">Source Type</p>
  <p-multiSelect
    [options]="ESGSourcesList"
    [(ngModel)]="selectedESGSourceType"
    placeholder="Select Source"
    optionLabel="sourceType"
    (onPanelShow)="onMultiSelectOpen()"
    (onChange)="updateFiltersSource()"
    (onClear)="updateFiltersSource(true)"
    display="chip"
    class="custom-multiSelect mt-1"
    [showClear]="true"
  >
  </p-multiSelect>

  <p class="heading">Documents</p>
  <p-multiSelect
    [options]="ESGDocumentNameList"
    [(ngModel)]="selectedESGDocumentName"
    placeholder="Select Document"
    optionLabel="documentName"
    (onPanelShow)="onMultiSelectOpen()"
    (onChange)="updateFiltersDocuments()"
    (onClear)="updateFiltersDocuments(true)"
    display="chip"
    class="custom-multiSelect mt-1"
    [showClear]="true"
  >
  <ng-template let-option pTemplate="item">
    <div class="option-item">
      <span>{{ option.documentName }}</span>
      <div class="icon-wrapper"  (click)="preventOptionClick($event)"
            (mousedown)="handleIconClick($event, option)">
        <i class="bi bi-card-text"></i>
      </div>
    </div>
  </ng-template>
  </p-multiSelect>

  <button
    type="button"
    [disabled]="selectedESGDocumentName?.length === 0  && selectedESGSourceType?.length === 0 && selectedESGTags?.length === 0"
    (click)="addDocs()"
    class="btn-sm processBtn mr-2 mt-2"
    >
    Submit
  </button>
</div>



